module.exports = __webpack_public_path__ + "static/media/avatar-dark.65fa10c1.svg";